import {
  ADD_SITE,
  ADD_ASSET,
  ADD_SITES,
  UPDATE_SITE,
  REMOVE_SITE,
  UPDATE_ASSET,
  REMOVE_ASSET,
  REMOVE_SITES,
  REMOVE_ASSETS,
  UPDATE_ASSETS,
  REMOVE_DROPPED_ASSET,
} from "../actions/asset.action";
import { createReducer, on } from "@ngrx/store";
import { SiteModel, AssetModel } from "../models/asset.model";

const INITIAL_STATE_SITE: SiteModel = {};
const INITIAL_STATE_SITES: SiteModel[] = [];

function updateAssets(
  updatedAsset: AssetModel,
  currentAssets: AssetModel[],
): AssetModel[] {
  const existingAssetIndex = currentAssets.findIndex(
    (asset) => asset.uid === updatedAsset.uid,
  );

  if (existingAssetIndex === -1) {
    return [...currentAssets, updatedAsset];
  }
  return currentAssets.map((asset) =>
    asset.uid === updatedAsset.uid ? { ...asset, ...updatedAsset } : asset,
  );
}

function updateAssetsBulk(
  updatedAssets: AssetModel[],
  currentAssets: AssetModel[],
): AssetModel[] {
  if (!currentAssets || currentAssets.length === 0) return updatedAssets;

  // Create lookup map
  const updatedMap = new Map(
    updatedAssets.map((asset) => [asset.uid, asset]),
  );

  // Merge in one pass
  return currentAssets.map((asset) =>
    updatedMap.has(asset.uid)
      ? { ...asset, ...updatedMap.get(asset.uid)! }
      : asset,
  );
}

export const SiteReducer = createReducer(
  INITIAL_STATE_SITE,
  on(ADD_SITE, (_, site) => site),
  on(ADD_ASSET, (state, asset) => ({
    ...state,
    assets: [...(state.assets || []), asset],
  })),

  on(UPDATE_ASSET, (state, asset) => ({
    ...state,
    assets: updateAssets(asset, state.assets || []),
  })),
  
  on(UPDATE_ASSETS, (state, { assets }) => ({
    ...state,
    assets: updateAssetsBulk(assets, state.assets || []),
  })),

  on(REMOVE_ASSET, (state, asset) => ({
    ...state,
    assets: (state.assets || []).filter(
      (prevAsset) => prevAsset.uid !== asset.uid,
    ),
  })),

  on(REMOVE_DROPPED_ASSET, (state, asset) => ({
    ...state,
    assets: (state.assets || []).filter(
      (prevAsset) => prevAsset.uid !== asset.uid,
    ),
  })),
  on(REMOVE_SITE, () => ({})),
  on(REMOVE_ASSETS, (state) => ({ ...state, assets: [] })),
  on(UPDATE_SITE, (state, site) => ({ ...state, ...site })),
);

export const SitesReducer = createReducer(
  INITIAL_STATE_SITES,
  on(REMOVE_SITES, () => []),
  on(ADD_SITES, (state, { sites }) => [...state, ...sites]),
);
